import dayjs from "dayjs";

const getFormattedDate = (str) => {
  return dayjs(str).format("DD/MM/YY,HH:mm");
};
export const getFormattedDateOnly = (str) => {
  return dayjs(str).format("DD/MM/YY");
};

export const convertSecondsToTAT = (value ,format) => {
  const seconds = value;
  const days = Math.floor(seconds / (3600 * 24));
  const hours = Math.floor((seconds % (3600 * 24)) / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  switch (format) {
    case "days":
      return `${days} D`;
    case "daysHoursMinutes":
    default:
      return `${days}D ${hours}H ${minutes} M`;
  }
};

export default getFormattedDate